import { Route, Routes, useNavigate } from 'react-router-dom'
import { useAuth } from './auth'
import { AuthLayout } from './components/AuthLayout'
import { GuestLayout } from './components/GuestLayout'
import { AvvisiProvider } from './contexts/AvvisiContext'
import { AreaClientiRedirect } from './pages/AreaClientiRedirect'
import { AttivazioneAccount } from './pages/AttivazioneAccount'
import Avvisi from './pages/Avvisi'
import AvvisiCliente from './pages/Avvisi/AreaCliente/AvvisiCliente'
import Bilance from './pages/Bilance'
import BilanciaCrea from './pages/BilanciaCrea'
import BilanciaDettaglio from './pages/BilanciaDettaglio'
import BilanciaDettaglioCliente from './pages/BilanciaDettaglio/BilanciaDettaglioCliente/BilanciaDettaglioCliente'
import CalendarioScadenze from './pages/CalendarioScadenze'
import ClienteDettaglio from './pages/ClienteDettaglio'
import ClienteDettaglioAreaClienti from './pages/ClienteDettaglio/AreaClienti/ClienteDettaglioAreaClienti'
import Clienti from './pages/Clienti'
import ClientiAreaClienti from './pages/Clienti/AreaClienti/ClientiAreaClienti'
import EsportazioneDettaglio from './pages/EsportazioneDettaglio'
import Esportazioni from './pages/Esportazioni'
import { FormProposta } from './pages/FormProposta'
import Interventi from './pages/Interventi'
import InterventiCliente from './pages/Interventi/InterventiCliente/InterventiCliente'
import InterventiCalendario from './pages/InterventiCalendario'
import InterventoDettaglio from './pages/InterventoDettaglio'
import InterventoDettaglioCliente from './pages/InterventoDettaglio/InterventoDettaglioCliente/InterventoDettaglioCliente'
import { Login } from './pages/Login'
import Opportunita from './pages/Opportunita'
import { PasswordDimenticata } from './pages/PasswordDimenticata'
import Profilo from './pages/Profilo'
import PropostaDettaglio from './pages/PropostaDettaglio'
import PropostaDettaglioCliente from './pages/PropostaDettaglio/PropostaDettaglioCliente/PropostaDettaglioCliente'
import Proposte from './pages/Proposte'
import ProposteCliente from './pages/Proposte/ProposteCliente/ProposteCliente'
import { ResetPassword } from './pages/ResetPassword'
import Utenti from './pages/Utenti'
import { useIsCliente } from './utils/utils'

export function Navigation() {
  const isCliente = useIsCliente()
  const { performLogout } = useAuth()
  const navigate = useNavigate()
  return (
    <AvvisiProvider>
      <Routes>
        <Route path="/" element={<AuthLayout redirect_to="/login" />}>
          {isCliente && (
            <>
              <Route index element={<Bilance />} />
              <Route path="/clienti" element={<ClientiAreaClienti />}></Route>
              <Route path="/clienti/:id" element={<ClienteDettaglioAreaClienti />}></Route>
              <Route path="bilance" element={<Bilance />} />
              <Route path="bilance/:id" element={<BilanciaDettaglioCliente />} />
              <Route path="/interventi" element={<InterventiCliente />}></Route>
              <Route path="/interventi-calendario" element={<InterventiCalendario />}></Route>
              <Route path="/interventi-scadenze" element={<CalendarioScadenze />}></Route>
              <Route path="/interventi/:id" element={<InterventoDettaglioCliente />}></Route>
              <Route path="/proposte" element={<ProposteCliente />}></Route>
              <Route path="/proposte/:id" element={<PropostaDettaglioCliente />}></Route>
              <Route path="/avvisi" element={<AvvisiCliente />}></Route>
              <Route path="utenti" element={<Utenti />}></Route>
              <Route path="profilo" element={<Profilo />}></Route>

              <Route path="*" element={<AreaClientiRedirect />} />
            </>
          )}
          {!isCliente && (
            <>
              <Route index element={<Bilance />}></Route>
              <Route path="/clienti" element={<Clienti />}></Route>
              <Route path="/clienti/:id" element={<ClienteDettaglio />}></Route>
              <Route path="/bilance" element={<Bilance />}></Route>
              <Route path="/bilance/:id" element={<BilanciaDettaglio />}></Route>
              <Route path="/bilance/crea" element={<BilanciaCrea />}></Route>
              <Route path="/interventi" element={<Interventi />}></Route>
              <Route path="/interventi-calendario" element={<InterventiCalendario />}></Route>
              <Route path="/interventi-scadenze" element={<CalendarioScadenze />}></Route>
              <Route path="/interventi/:id" element={<InterventoDettaglio />}></Route>
              <Route path="/esportazioni" element={<Esportazioni />}></Route>
              <Route path="/esportazioni/:id" element={<EsportazioneDettaglio />}></Route>
              <Route path="/avvisi" element={<Avvisi />}></Route>
              <Route path="/opportunita" element={<Opportunita />}></Route>
              <Route path="/proposte" element={<Proposte />}></Route>
              <Route path="/proposte/:id" element={<PropostaDettaglio />}></Route>
              <Route path="/utenti" element={<Utenti />}></Route>
              <Route path="/profilo" element={<Profilo />}></Route>
            </>
          )}
        </Route>
        <Route path="/login" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<Login />}></Route>
        </Route>
        <Route path="/password-dimenticata" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<PasswordDimenticata />}></Route>
        </Route>
        <Route path="/resetta-password/:token" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<ResetPassword />}></Route>
        </Route>
        <Route path="/attiva-account/:token" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<AttivazioneAccount />}></Route>
        </Route>
        <Route path="/form-proposta/:id" element={<FormProposta />} />
        <Route
          path="/expired"
          element={
            <AreaClientiRedirect
              message="Sessione scaduta. Per favore effettua nuovamente il login."
              ctaLabel="Vai al login"
              onClick={() => {
                performLogout()
                navigate('/login')
              }}
            />
          }
        />
      </Routes>
    </AvvisiProvider>
  )
}
